import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useQuery } from '@apollo/client';
import { UI_SETTING_BY_NAME } from 'pages/ApplicationUI/ApplicationUIGraphQL';
import { APP_UI } from 'pages/ApplicationUI/constant';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ErrorMessage from 'components/ErrorMessage';
import Loader from 'components/common/Loader';
import AboutForm from './components/AboutForm';

const AboutUs = ({ handleSubmit }) => {
  const { data, loading, error, refetch } = useQuery(UI_SETTING_BY_NAME, {
    variables: { settingName: APP_UI.ABOUT_US },
    fetchPolicy: 'network-only',
  });

  const AboutValidation = Yup.object().shape({
    settingValue: Yup.string().required('About us is required').trim(),
  });

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    <Row>
      <Col xl={12}>
        <Card className="border-0 card-box">
          <CardBody>
            <h4 className="f-16 fw-semibold mb-3">About us</h4>
            <ErrorBoundary>
              {loading ? (
                <Loader />
              ) : (
                <Formik
                  validationSchema={AboutValidation}
                  initialValues={data.findBySettingName || { settingValue: '' }}
                  onSubmit={(values) => handleSubmit(values, refetch)}
                  children={(props) => {
                    return <AboutForm {...props} />;
                  }}
                  enableReinitialize
                />
              )}
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AboutUs;
